var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('userroles',{attrs:{"userroles":_vm.userRoles,"usergroups":_vm.userGroups,"modulesubmodules":_vm.moduleSubmodules},on:{"userRoleChange":function($event){return _vm.getUserRoles()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }